import Head from 'next/head';
import LandingHeader from '@/components/Landing/Header';
import LandingFooter from '@/components/Landing/Footer';
import React from 'react';
import style from './style.module.scss';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

const Products = () => {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>Tiger.Trade</title>
        <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-touch-icon.png" />
        <link rel="icon" href="/images/favicon.svg" />
        <link rel="icon" type="image/png" sizes="32x32" href="/images/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/images/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#080610" />
        <meta name="msapplication-TileColor" content="#080610" />
        <meta name="theme-color" content="#080610" />
      </Head>
      <LandingHeader />
      <div className={style.main}>
        <div className={style.policyPage}>
          <div className={style.mainContainer}>
            <Link href={'/'}>
              <div className={style.back}>
                <div className={style.arrow} />
                <span>{t('back_1')}</span>
              </div>
            </Link>
            <div className={style.content}>
              {router.locale !== 'ru' ? (
                <>
                  <h1 className={style.title}>PERSONAL DATA PROCESSING POLICY</h1>
                  <span className={style.text}>
                    By using the Tiger.com Website, You provide Your Personal data to the Data
                    Controller, agree to the Data Controller's processing of the same in accordance
                    with the procedures set forth in this Policy and agree to the terms and
                    conditions of this Policy.
                  </span>
                  <h2 className={style.subTitle}>INTRODUCTION</h2>
                  <div>
                    <div className={style.text_split}>
                      1. This document (i) defines Data Controller's policy with respect to
                      processing of Personal data which the Data Controller collects using the
                      Internet, and (ii) contains information on Personal data protection
                      requirements implemented ("Policy").
                    </div>
                    <div className={style.text_split}>
                      2. The Policy applies to Personal data which the Data Controller may receive
                      from the Website's user ("You" or "Website User") when You use Website for
                      various purposes.
                    </div>
                    <div className={style.text_split}>
                      3. Please feel free to contact the Data Controller any time with any questions
                      regarding Your Personal data processing or to request that Your Personal data
                      be modified (updated, supplemented, or revised), or to revoke Your consent to
                      the Personal data processing within the scope and for the purposes referred to
                      in the Policy.
                    </div>
                    <div className={style.text_split}>
                      In any such case, please send Your request in any form by email at
                      <a href="mailto:support@tiger.com">support@tiger.com</a>.
                    </div>
                  </div>
                  <h2 className={style.subTitle}>DEFINITIONS</h2>
                  <div className={style.text_split}>
                    4. Below are the main terms used in this Policy: <br /> —{' '}
                    <b>"Data Controller"</b> means the respective company authorized by Tiger.com
                    for operating as Data Controller, which arranges for and conducts Personal data
                    processing and defines purposes of the Personal data processing, the scope of
                    Personal data to be processed, and actions/operations to be carried out with
                    Personal data; <br /> — <b>"Website"</b> means internet Website located at
                    <a href="https://www.tiger.com/" target="_blank">
                      https://www.tiger.com/
                    </a>
                    . <br /> — <b>"PD Regulations"</b> mean any regulations adopted in pursuance of
                    such law, General Data Protection Regulation, or any other applicable laws
                    governing the protection of personal data; <br /> —{' '}
                    <b>"Personal data processing"</b> means any action/operation or a set of
                    actions/operations with personal data carried out with or without the use of any
                    automation tools; a list of actions carried out by the Data Controller with Your
                    personal data is given in clause 14 below; <br /> — <b>"Personal data"</b> means
                    any information directly or indirectly related to an identified or identifiable
                    individual (personal data subject), i.e., information that directly identifies
                    You (such as Your name or email address) and information that does not identify
                    You directly, but may be used in one way or another for identification (e.g.,
                    Your mobile device details); <br /> — <b>"You" or "Website User"</b> mean any
                    individual using the Website.
                  </div>
                  <div className={style.text_split}>
                    5. The Data Controller shall provide unrestricted access to this Policy by
                    posting its current version in the Privacy Policy section in the Website, and a
                    hard copy of the same shall be kept in the Data Controller's office and may be
                    provided to You at Your request or otherwise under the PD Regulations.
                  </div>
                  <div className={style.text_split}>
                    6. This Policy shall be revised or updated if the Data Controller's data
                    processing procedures are modified, or the PD Regulations are amended.
                  </div>
                  <h2 className={style.subTitle}>
                    DATA CONTROLLER'S PERSONAL DATA PROCESSING PRINCIPLES, TERMS, AND CONDITIONS
                  </h2>
                  <div className={style.text_split}>
                    7. The Data Controller will process Your personal data in accordance with the
                    procedures stipulated by the PD Regulations on a fair and lawful basis.
                  </div>
                  <div className={style.text_split}>
                    8. The Data Controller will process Your personal data strictly for the purposes
                    defined in this Policy and such processing will be limited to the attainment of
                    such specific, pre-defined, and lawful purposes. The Data Controller undertakes
                    not to allow any personal data processing that is inconsistent with the purposes
                    for which such data is collected as listed in this Policy. The personal data
                    that the Data Controller collects in the Website is not excessive relative to
                    the declared purposes for which the same is processed.
                  </div>
                  <div className={style.text_split}>
                    9. The Data Controller will store Your personal data in a form that makes it
                    possible to identify You as a personal data subject for no longer than the
                    purposes of personal data processing require unless the PD Regulations require
                    otherwise. Unless the PD Regulations require otherwise, the Data Controller will
                    destroy Your personal data once these purposes are achieved or if processing is
                    no longer necessary, Your personal data will be deleted. If any personal data is
                    found to be inaccurate or unlawfully processed, it will be blocked, updated, or
                    deleted in accordance with clause 29 of this Policy.
                  </div>
                  <h2 className={style.subTitle}>
                    LEGAL REASONS FOR DATA CONTROLLER'S PERSONAL DATA PROCESSING
                  </h2>
                  <div className={style.text_split}>
                    10. The Data Controller will process Your personal data solely and exclusively
                    subject to there being legal reasons under the PD Regulations, and such legal
                    reasons are as follows:
                  </div>
                  <div className={style.text_split}>
                    — Your consent for personal data processing with respect to marketing and
                    research activities between the Data Controller and You (such as promotion of
                    Tiger.com products or other marketing interaction and studies); <br /> — Your
                    consent for personal data processing with respect to Your personal data shared
                    through the Website or otherwise; <br /> — compliance with applicable laws,
                    including, without limitation, those that assign the Data Controller's
                    functions, powers, and duties; <br /> — exercise of rights and legitimate
                    interests of the Data Controller or third parties in compliance with the PD
                    Regulations.
                  </div>
                  <h2 className={style.subTitle}>PROCESSED PERSONAL DATA SCOPE AND PURPOSES</h2>
                  <div className={style.text_split}>
                    11. This Policy describes procedures used by the Data Controller to process
                    personal data of the Website Visitors.
                  </div>
                  <div className={style.text_split}>
                    12. When You use the Website as a Website Visitor, the Data Controller collects
                    data passively. The content, purposes, and scope of personal data collected in
                    such event is further described in clauses 14 and 15 of this Policy.
                  </div>
                  <div className={style.text_split}>
                    13. Also, if You contact the Data Controller using the contact form on the
                    Website or, in accordance with clause 3 of this Policy, the Data Controller will
                    also process personal data You share, which may include Your name, email
                    address, telephone number, message subject and body, and other data shared by
                    You. The Data Controller will use such data to process Your query (e.g., to
                    respond to Your questions or requests, e.g., to send You requested documents or
                    information).
                  </div>
                  <div className={style.text_split}>
                    14. The Data Controller will use personal data shared by the Website Visitors
                    for the following purposes:
                  </div>
                  <div className={style.text_split}>
                    — to administer and protect our business and this Website (including
                    troubleshooting, data analysis, testing, system maintenance, support, reporting
                    and hosting of data); <br /> — to deliver relevant Website content and
                    advertisements to You and measure or understand the effectiveness of the
                    advertising we serve to You; <br /> — to use data analytics to improve our
                    Website, products/services, marketing, customer relationships and experiences;
                    and <br /> — to make suggestions and recommendations to You about goods or
                    services that may be of interest to You.
                  </div>
                  <h2 className={style.subTitle}>INTERACTIVE DATA COLLECTION TECHNOLOGIES</h2>
                  <div className={style.text_split}>
                    15. To collect the Website browsing and user behavior data, such technologies as
                    cookies (browser cookies and Flash cookies) and web beacons are used on the
                    Website. The Data Controller and third-party vendors, acting under an agreement
                    with the Data Controller, passively collect and use data variously, including:
                  </div>
                  <div className={style.text_split}>
                    — Via a browser: certain data is collected by most browsers, e.g., Your Media
                    Access Control (MAC) address, computer type and operating system version,
                    Internet browser type and version, and Visitor location. The Data Controller may
                    collect such information as, for example, Your device type and identifier, if
                    You access the Website from a mobile device. Such information is shared with the
                    Data Controller when a Visitor accesses the Website. <br /> — Using Cookies:
                    Cookies are small text files stored on Your computer. Cookies allow the Data
                    Controller to collect such information as the browser type, time spent on the
                    Website, web pages viewed, and language preferences. For visitors in Europe and
                    the UK, we will request consent to use non-essential cookies, such as analytical
                    cookies, and these will not be placed unless and until consent is provided by
                    You. <br /> The Data Controller and third-party vendors use this data to improve
                    the Website operation, ensure security, facilitate browsing, display information
                    more efficiently, and customize Your experience of using the Website. <br /> The
                    Data Controller also uses cookies to identify Your computer or device which
                    makes it easier for You to use the Website. <br /> Also, the Data Controller
                    uses cookies to collect the Website statistics and analytics for ongoing
                    improvements of its design and functionality, to better understand how
                    individual visitors use the Website, and to assist in addressing any issues of
                    concern (including for the Data Controller's arrangements with third parties).
                    Specifically, the Data Controller uses Google Tag Manager. Third-party vendors
                    of the Data Controller, and, in particular, Google Display Network, may use
                    cookies for online advertising purposes. Your relationships with such
                    third-party vendors are governed by terms of use of such third-party vendors (
                    <a href="https://policies.google.com/technologies/ads?hl=en-US" target="_blank">
                      https://policies.google.com/technologies/ads?hl=en-US
                    </a>
                    ). <br /> If You share any information from the Website on any social media,
                    such social media cookies may also be used. <br /> You may disable cookies
                    following the appropriate instructions of Your browser. To learn more about
                    cookies, please go to
                    <a href="http://www.allaboutcookies.org" target="_blank">
                      www.allaboutcookies.org
                    </a>
                    . <br /> If You disable cookies, certain Website features may work incorrectly.{' '}
                    <br /> — IP address: IP address is a numerical label Your Internet provider
                    assigns to Your computer automatically. The IP address is identified and logged
                    in the Data Controller's server files each time a Website Visitor accesses the
                    Website; web pages viewed, and time spent on the Website are also logged.
                    Collection of IP addresses is a common Internet practice with many websites
                    collecting such data automatically. The Data Controller uses IP addresses for
                    such purposes as, for example, to assess the Website traffic, for server
                    diagnostics and Website administration. <br /> — Device Information: The Data
                    Controller may collect Your mobile device data, e.g., the unique device
                    identifier.
                  </div>
                  <h2 className={style.subTitle}>
                    PERSONAL DATA PROCESSING PROCEDURES, TERMS, AND CONDITIONS
                  </h2>
                  <div className={style.text_split}>
                    16. This Policy applies to collection, recording, classification, capture,
                    storage, revision (updating, modification), retrieval, use, transfer (sharing,
                    accessing), cross-border transfer, blocking, deletion, and destruction of
                    personal data collected by the Data Controller on the Website with the use of
                    automation tools. The source of Your personal data is You. We do not collect
                    personal data about You from a third-party.
                  </div>
                  <div className={style.text_split}>
                    17. The Data Controller processes Your personal data automatically without
                    making any decisions that have any legal implications or otherwise affect Your
                    rights and legitimate interests based solely on personal data automated
                    processing.
                  </div>
                  <div className={style.text_split}>
                    18. The Data Controller will ensure that databases used for collection,
                    recording, classification, capture, storage, revision (updating, modification)
                    and retrieval of personal data are in compliance with the PD Regulations.
                  </div>
                  <div className={style.text_split}>
                    19. The Data Controller will keep Your personal data collected on the Website
                    confidential.
                  </div>
                  <div className={style.text_split}>
                    20. The Data Controller may delegate the processing of Your personal data to a
                    third party, subject to the PD Regulations.
                  </div>
                  <div className={style.text_split}>
                    21. The Data Controller will transfer Your personal data collected on the
                    Website in the following events:
                  </div>
                  <div className={style.text_split}>
                    — You have authorized such transfer; <br /> — such transfer is required to
                    achieve any purposes of an international treaty or a law, or to fulfil and
                    discharge any functions, powers, and duties of the Data Controller under
                    applicable laws; or <br /> — such transfer is required to perform an agreement
                    to which You are party.
                  </div>
                  <div className={style.text_split}>
                    22. The Data Controller will share personal data collected on the Website only
                    if the Data Controller has entered into an agreement with the recipient of
                    personal data under which such third party receiving personal data from the Data
                    Controller undertakes to keep personal data confidential and to adhere to the
                    personal data processing principles and rules defined by the PD Regulations and
                    agreement with the Data Controller.
                  </div>
                  <div className={style.text_split}>
                    23. The Data Controller will share personal data (including by cross-border
                    transfer to countries that do or do not provide an adequate level of protection
                    of personal data subjects' rights) with the following third parties: <br /> —
                    affiliates of the Data Controller; <br /> — third-party vendors of such services
                    as Website hosting and administration, data analytics, infrastructure
                    maintenance, IT services, services delivered by email or regular mail, audit
                    services, and other services, if such data is needed for such persons to be able
                    to provide the same; and <br /> — in the event of restructuring, merger, sale,
                    creation of a joint venture, or winding up of the Data Controller, transfer of
                    its assets or shares in full or in part (including in connection with bankruptcy
                    or court proceedings).
                  </div>
                  <div className={style.text_split}>
                    24. The Data Controller will share personal data collected on the Website within
                    the scope which the Data Controller may in its discretion deem necessary or
                    appropriate:
                  </div>
                  <div className={style.text_split}>
                    — to effectively achieve purposes listed in clause 14 above; <br /> — pursuant
                    to requirements of the laws applicable to the Data Controller; <br /> — to
                    protect the Data Controller's and its affiliates' business; <br /> — in response
                    to requests from the government authorities; <br /> — to facilitate any court
                    proceedings; or <br /> — to protect Your rights and rights of the Data
                    Controller, confidentiality, security, or property and/or rights,
                    confidentiality, security, or property of the Data Controller and its
                    affiliates.
                  </div>
                  <div className={style.text_split}>
                    25. When processing personal data, the Data Controller will make sure that
                    personal data is accurate (assuming such data is true without having to verify
                    the same), sufficient, and, where necessary, and fit for purpose. The Data
                    Controller will take appropriate measures to delete or update incomplete or
                    inaccurate data, including in the events referred to in this Policy.
                  </div>
                  <div className={style.text_split}>
                    26. The Data Controller will apply required managerial, technical, and
                    administrative arrangements to protect personal data received on the Website in
                    accordance with the PD Regulations.
                  </div>
                  <h2 className={style.subTitle}>PERSONAL DATA PROCESSING TERM AND TERMINATION</h2>
                  <div className={style.text_split}>
                    27. The Data Controller will store personal data collected on the Website for as
                    long as necessary for the purposes of this Policy unless longer storage is
                    necessary or permitted by the laws applicable to the Data Controller.
                  </div>
                  <div className={style.text_split}>
                    28. The Data Controller may terminate personal data processing once the purposes
                    of such processing have been attained or where such processing is found to be
                    illegitimate.
                  </div>
                  <div className={style.text_split}>
                    29. If processing of personal data collected on the Website is found to be
                    illegitimate (on receipt of Your or Your representative's query, on receipt of a
                    request from an authorized agency, or following an internal audit) or if
                    personal data is found to be inaccurate, the Data Controller will block or
                    procure the blocking of such personal data that is processed illegitimately on
                    receipt of such query or request for as long as such personal data processing is
                    verified:
                  </div>
                  <div className={style.text_split}>
                    — if the inaccuracy of personal data is confirmed based on the information You,
                    Your authorized representative, or an authorized agency may provide in any form
                    in writing or based on any other documents pursuant to PD Regulations, the Data
                    Controller shall update such personal data or procure the same to be updated
                    within seven (7) business days of receipt of such data and unblock the same;{' '}
                    <br /> — if the illegitimate personal data processing is confirmed, the Data
                    Controller shall terminate such illegitimate processing within three (3)
                    business days of confirmation of the illegitimate processing or delete such
                    personal data within ten (10) business days of confirmation of the illegitimate
                    processing. The Data Controller shall notify You, or Your representative, or the
                    authorized agency, if the legitimacy of processing was verified at the request
                    of such agency, of remedying any such violations.
                  </div>
                  <div className={style.text_split}>
                    30. If You revoke Your consent, the Data Controller shall terminate personal
                    data processing immediately, except when continued processing of such personal
                    data is required by the laws applicable to the Data Controller, and in any event
                    the Data Controller shall notify You of the outcome of such revocation.
                  </div>
                  <div className={style.text_split}>
                    31. If the purposes for which personal data collected on the Website have been
                    attained, the Data Controller shall terminate personal data processing and
                    destroy personal data within thirty (30) days of when the purposes of processing
                    have been attained, unless Your consent received by the Data Controller provides
                    for a different deadline. If personal data collected on the Website may not be
                    destroyed by such deadline, the Data Controller will block such personal data
                    and ensure that the same is destroyed within six (6) months, unless the laws
                    applicable to the Data Controller, Your consent for personal data processing, or
                    an agreement to which You are a party, require otherwise.
                  </div>
                </>
              ) : (
                <>
                  <h1 className={style.title}>
                    ПОЛИТИКА В ОТНОШЕНИИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                  </h1>
                  <span className={style.text}>
                    Если Вы используете Сайт, Вы: предоставляете Оператору свои персональные данные;
                    и соглашаетесь на их обработку Оператором в порядке, который описан в настоящей
                    Политике. Продолжая использовать Сайт, Вы соглашаетесь с условиями и положениями
                    Политики.
                  </span>
                  <h2 className={style.subTitle}>ОБЩИЕ ПОЛОЖЕНИЯ</h2>
                  <div>
                    <div className={style.text_split}>
                      1. Настоящий документ (i) определяет политику Оператора в отношении обработки
                      Персональных данных, сбор которых осуществляется Оператором с использованием
                      информационно-телекоммуникационной сети Интернет, и (ii) содержит сведения о
                      реализуемых требованиях к защите таких персональных данных («Политика»).
                    </div>
                    <div className={style.text_split}>
                      2. Политика действует в отношении персональных данных, которые Оператор может
                      получить от посетителя («Вы») в ходе посещения Вами Интернет-сайта Оператора,
                      расположенного по адресу{' '}
                      <a href="https://www.tiger.com/" target="_blank">
                        https://www.tiger.com/
                      </a>{' '}
                      (далее – «Сайт»).
                    </div>
                    <div className={style.text_split}>
                      3. Вы имеете право в любой момент обратиться к Оператору с любыми вопросами,
                      касающимися порядка обработки Ваших персональных данных и получить доступ к
                      Вашим персональным данным, а также обратиться с требованием изменить
                      (обновить, дополнить, уточнить) Ваши персональные данные, либо отозвать свое
                      согласие на обработку персональных данных в объеме и в целях, указанных в
                      Политике. Во всех указанных случаях, пожалуйста, направьте Ваше обращение в
                      свободной форме по адресу электронной почты{' '}
                      <a href="mailto:support@tiger.com">support@tiger.com</a>.
                    </div>
                  </div>
                  <h2 className={style.subTitle}>ОСНОВНЫЕ ПОНЯТИЯ</h2>
                  <div className={style.text_split}>
                    4. Основные термины, используемые в Политике: <br /> —«Законодательство о ПДн» –
                    применимые законы и нормативно-правовые акты, регулирующие деятельность по
                    обработке персональных данных; <br /> — «Оператор» – соответствующая компания,
                    уполномоченная Tiger.com выступать в качестве Оператора, организующая и
                    осуществляющая обработку персональных данных, а также определяющая цели
                    обработки персональных данных, состав персональных данных, подлежащих обработке,
                    действия (операции), совершаемые с персональными данными; <br /> — «Обработка
                    персональных данных» – любое действие (операция) или совокупность действий
                    (операций) с персональными данными, совершаемые с использованием средств
                    автоматизации или без их использования; и перечень действий, которые совершаются
                    Оператором с Вашими персональными данными, приведен ниже в пункте 16 Политики;{' '}
                    <br /> — «Персональные данные» – любая информация, относящаяся к прямо или
                    косвенно определенному или определяемому физическому лицу (субъекту персональных
                    данных), то есть информация, которая идентифицирует Вас напрямую (например, имя
                    или адрес электронной почты), а также информация, которая прямо Вас не
                    идентифицирует, но может быть использована тем или иным образом для
                    идентификации (например, данные Вашего мобильного устройства); <br /> — «Вы» или
                    «Посетитель Сайта» – любое физическое лицо, которое использует Сайт для любых
                    целей.
                  </div>
                  <div className={style.text_split}>
                    5. Оператор обеспечивает неограниченный доступ к Политике путем размещения ее
                    действующей редакции в разделе «Политика конфиденциальности» на Сайте, а
                    редакция на бумажном носителе хранится по адресу Оператора и может быть
                    предоставлена по Вашему запросу или в иных случаях согласно Законодательству о
                    ПДн.
                  </div>
                  <div className={style.text_split}>
                    6. Политика подлежит пересмотру и, при необходимости, актуализации в случае
                    изменений в порядке обработки данных у Оператора либо в случае изменений
                    Законодательства о ПДн.
                  </div>
                  <h2 className={style.subTitle}>
                    ПРИНЦИПЫ И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ ОПЕРАТОРОМ
                  </h2>
                  <div className={style.text_split}>
                    7. Оператор обрабатывает Ваши персональные данные в порядке, предусмотренном
                    Законодательством о ПДн, на законной и справедливой основе.
                  </div>
                  <div className={style.text_split}>
                    8. Обработка Ваших персональных данных осуществляется Оператором строго в целях,
                    определенных в Политике, и ограничивается достижением таких конкретных, заранее
                    определенных и законных целей. Оператор обязуется не допускать обработку
                    персональных данных, несовместимую с целями их сбора, указанными в Политике.
                    Персональные данные, собираемые на Сайте Оператором, не являются избыточными по
                    отношению к заявленным целям их обработки.
                  </div>
                  <div className={style.text_split}>
                    9. Ваши персональные данные хранятся у Оператора в форме, позволяющей определить
                    Вас как субъекта персональных данных, не дольше, чем этого требуют цели
                    обработки персональных данных, если иной порядок не предусмотрен
                    Законодательством о ПДн. Если только иное не предусмотрено Законодательством о
                    ПДн, Ваши персональные данные будут уничтожены Оператором, после того как будут
                    достигнуты цели обработки, в порядке, предусмотренном в пункте 31 Политики, либо
                    в случае, если отпадет необходимость в обработке Ваших персональных данных для
                    таких целей.
                  </div>
                  <h2 className={style.subTitle}>
                    ПРАВОВЫЕ ОСНОВАНИЯ ДЛЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ ОПЕРАТОРОМ
                  </h2>
                  <div className={style.text_split}>
                    10. Обработка Ваших персональных данных осуществляется Оператором исключительно
                    при наличии правового основания, предусмотренного Законодательством о ПДн, и
                    такими правовыми основаниями являются:
                  </div>
                  <div className={style.text_split}>
                    — Ваше согласие на обработку персональных данных в связи с маркетинговыми и
                    исследовательскими мероприятиями между Оператором и Вами (например, продвижение
                    продуктов Tiger.com или иные маркетинговые взаимодействия и исследования);{' '}
                    <br /> — исполнение требований Законодательства о ПДн, в частности, возлагающих
                    на Оператора функции, полномочия и обязанности; или <br /> — осуществление прав
                    и законных интересов Оператора или третьих лиц (при условии, что при этом
                    Оператором не нарушаются права и свободы субъектов персональных данных).
                  </div>
                  <h2 className={style.subTitle}>
                    СОСТАВ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ И ЦЕЛИ ОБРАБОТКИ
                  </h2>
                  <div className={style.text_split}>
                    11. Политика описывает порядок обработки Оператором Персональных данных
                    Посетителей Сайта.
                  </div>
                  <div className={style.text_split}>
                    12. При использовании Сайта Вами как Посетителем Сайта Оператор осуществляет
                    пассивный сбор информации. Содержание, цели и объем персональных данных,
                    собираемых в таких случаях, подробнее описаны в пунктах 14 и 15 Политики.
                  </div>
                  <div className={style.text_split}>
                    13. Кроме того, если Вы обращаетесь к Оператору, используя форму обратной связи,
                    размещенную на Сайте или, в соответствии с порядком, предусмотренным в пункте 3
                    Политики, то Оператор также будет обрабатывать предоставленные Вами персональные
                    данные, которые могут включать имя, контактный адрес электронной почты,
                    контактный номер телефона, тему и текст сообщения, иные предоставленные Вами
                    данные. Указанные данные будут использоваться Оператором для целей обработки
                    Вашего запроса (например, для ответа на Ваши вопросы или для выполнения Вашего
                    запроса документов или информации).
                  </div>
                  <div className={style.text_split}>
                    14. Предоставленные Посетителем Сайта персональные данные используются
                    Оператором в следующих целях:
                  </div>
                  <div className={style.text_split}>
                    — для администрирования и защиты нашего бизнеса и этого Сайта (включая
                    устранение неполадок, анализ данных, тестирование, обслуживание информационных
                    систем, поддержку, отчетность и размещение данных); <br /> — для предоставления
                    Вам релевантного контента и рекламы на Сайте, а также для оценки или понимания
                    эффективности рекламы, которую мы Вам предоставляем; <br /> — для использования
                    аналитики данных с целью улучшения нашего Сайта, продуктов/услуг, маркетинга,
                    взаимоотношений с клиентами и опыта; а также <br /> — для подготовки предложений
                    и рекомендаций по товарам или услугам, которые могут Вас заинтересовать.
                  </div>
                  <h2 className={style.subTitle}>ТЕХНОЛОГИИ ИНТЕРАКТИВНОГО СБОРА ДАННЫХ</h2>
                  <div className={style.text_split}>
                    15. На Сайте используются такие технологии, как файлы cookie (cookie
                    интернет-браузера и Flash-cookie) и веб-маяки, для сбора информации о посещении
                    Сайта и о пользовательском поведении на Сайте. Оператор и сторонние поставщики
                    услуг по соглашению с Оператором пассивно собирают и используют информацию
                    различными способами, в том числе:
                  </div>
                  <div className={style.text_split}>
                    — Через браузер: определенная информация собирается большинством браузеров,
                    например, Ваш адрес управления доступом к среде передачи данных (Media Access
                    Control, MAC), тип и версия операционной системы Вашего компьютера, тип и версия
                    Интернет-браузера, местоположение Посетителя Сайта. Оператор может собирать
                    такую информацию, как, например, тип и идентификатор Вашего устройства, если Вы
                    заходите на Сайт через мобильное устройство. Указанная информация передается
                    Оператору при обращении Посетителя Сайта к Сайту. <br /> — Используя файлы
                    cookie: Файлы cookie – это фрагменты информации, которые хранятся
                    непосредственно на используемом Вами компьютере. Файлы cookie позволяют
                    Оператору собирать такую информацию, как тип браузера, время, проведенное на
                    Сайте, просмотренные страницы и предпочтения языка. <br /> — Оператор и
                    сторонние поставщики услуг Оператора используют эту информацию в целях улучшения
                    работы Сайта, обеспечения безопасности, чтобы облегчить навигацию, более
                    эффективно отображать информацию и персонализировать использование Вами Сайта.{' '}
                    <br /> — Оператор также использует файлы cookie, чтобы распознавать Ваш
                    компьютер или устройство, что облегчает использование Вами Сайта. <br /> — Кроме
                    того, Оператор использует файлы cookie для того, чтобы собрать статистическую и
                    аналитическую информацию об использовании Сайта в целях постоянного
                    усовершенствования его дизайна и функциональности, понимания того, как отдельные
                    лица используют его, и содействия при разрешении вопросов, связанных с ним (в
                    том числе, при организации работы Оператора с третьими лицами), в частности,
                    Оператор использует Google Tag Manager. <br /> — Сторонние поставщики услуг
                    Оператора, в частности, Google Display Network могут использовать файлы cookie
                    для целей онлайн-рекламы. Отношения между Вами и таким сторонним поставщиком
                    услуг регулируются условиями использования стороннего поставщика (
                    <a href="https://policies.google.com/technologies/ads?hl=en-US" target="_blank">
                      https://policies.google.com/technologies/ads?hl=en-US
                    </a>
                    ). <br /> — Если Вы делитесь в социальных сетях какой-либо информацией с Сайта,
                    то могут использоваться cookie таких социальных сетей. Вы можете отказаться от
                    использования файлов cookie, выполнив инструкции своего браузера. Чтобы узнать
                    больше о файлах cookie, посетите{' '}
                    <a href="http://www.allaboutcookies.org" target="_blank">
                      www.allaboutcookies.org
                    </a>
                    . При отключении файлов cookie часть функций Сайта может работать некорректно.{' '}
                    <br /> — IP-адрес: IP-адрес – это номер, который автоматически присваивается
                    Вашему компьютеру Вашим провайдером интернет-услуг. IP-адрес идентифицируется и
                    автоматически регистрируется в файлах сервера Оператора каждый раз, когда
                    Посетитель Сайта посещает Сайт; кроме того, регистрируется время визита и
                    просмотренные страницы. Сбор IP-адресов является стандартной практикой в
                    Интернете и производится автоматически многими веб-сайтами. Оператор использует
                    IP-адреса в таких целях, как расчет уровня посещаемости Сайта, диагностика
                    проблем на сервере и администрирование Сайта. <br /> — Информация об устройстве:
                    Оператор может собирать информацию о Вашем устройстве, например, уникальный
                    идентификатор устройства.
                  </div>
                  <h2 className={style.subTitle}>
                    ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                  </h2>
                  <div className={style.text_split}>
                    16. Действие Политики распространяется на процессы по сбору, записи,
                    систематизации, накоплению, хранению, уточнению (обновлению, изменению),
                    извлечению, использованию, передаче (предоставлению, доступу), трансграничной
                    передаче, блокированию, удалению и уничтожению персональных данных, собираемых
                    через Сайт Оператором с использованием средств автоматизации.
                  </div>
                  <div className={style.text_split}>
                    17. Оператор осуществляет автоматизированную обработку Ваших персональных
                    данных, но при этом Оператор не принимает решений, порождающих юридические
                    последствия или иным образом затрагивающих Ваши права и законные интересы, на
                    основании исключительно автоматизированной обработки персональных данных.
                  </div>
                  <div className={style.text_split}>
                    18. Оператор обеспечивает соответствие Законодательству о ПДн баз данных, с
                    использованием которых осуществляются сбор, запись, систематизация, накопление,
                    хранение, уточнение (обновление, изменение), извлечение персональных данных.
                  </div>
                  <div className={style.text_split}>
                    19. Оператор обеспечивает конфиденциальность Ваших персональных данных,
                    собираемых через Сайт.
                  </div>
                  <div className={style.text_split}>
                    20. Оператор вправе поручить обработку Ваших персональных данных третьему лицу с
                    соблюдением требований Законодательства о ПДн.
                  </div>
                  <div className={style.text_split}>
                    21. Оператор осуществляет предоставление персональных данных, собранных через
                    Сайт, в следующих случаях:
                  </div>
                  <div className={style.text_split}>
                    — Вы предоставили свое согласие на такие действия; <br /> — передача необходима
                    для достижения целей, предусмотренных Законодательством о ПДн; или <br /> —
                    передача необходима для исполнения договора, стороной которого Вы являетесь.
                  </div>
                  <div className={style.text_split}>
                    22. Оператор осуществляет предоставление персональных данных, собранных через
                    Сайт, при условии, что Оператор заключил договор с получателем персональных
                    данных, в соответствии с которым третье лицо, получающее от Оператора
                    персональные данные, обязуется соблюдать конфиденциальность персональных данных,
                    а также принципы и правила обработки персональных данных, определенные в
                    Законодательстве о ПДн и в договоре с Оператором.
                  </div>
                  <div className={style.text_split}>
                    23. Оператор осуществляет предоставление персональных данных (в том числе путем
                    трансграничной передачи в страны, как обеспечивающие, так и не обеспечивающие
                    адекватную защиту прав субъектов персональных данных) следующим третьим лицам:{' '}
                    <br /> — аффилированным лицам Оператора; <br /> — сторонним поставщикам услуг,
                    таких как хостинг и администрирование веб-сайта, анализ данных, обеспечение
                    инфраструктуры, IT-услуги, доставляемые по электронной и традиционной почте
                    услуги, услуги аудита и другие услуги, если такие данные необходимы таким лицам,
                    чтобы позволить им предоставлять свои услуги; и <br /> — в случае реорганизации,
                    слияния, продажи, создания совместного предприятия, ликвидации Оператора,
                    передачи активов или долей/акций Оператора полностью или частично (включая в
                    случае, когда вышеперечисленное осуществляется в связи с банкротством или
                    судебным процессом).
                  </div>
                  <div className={style.text_split}>
                    24. Оператор предоставляет персональные данные, собранные через Сайт, в объеме,
                    который, как считает Оператор, необходим или уместен: <br /> — в целях
                    эффективного достижения целей, указанных в пункте 14 выше; <br /> — в связи с
                    требованиями законодательства, применимыми к Оператору; <br /> — в целях защиты
                    деятельности Оператора и деятельности его аффилированных лиц; <br /> — в
                    качестве ответа на запросы государственных органов власти; <br /> — в целях
                    содействия судебному процессу; или <br /> — в целях защиты Ваших прав и прав
                    Оператора, конфиденциальности, безопасности или имущества и (или) прав,
                    конфиденциальности, безопасности или имущества Оператора и его аффилированных
                    лиц.
                  </div>
                  <div className={style.text_split}>
                    25. При обработке персональных данных Оператор обеспечивает точность
                    персональных данных (презюмируя их достоверность и не проверяя ее), их
                    достаточность, а в необходимых случаях и актуальность по отношению к целям
                    обработки. Оператор принимает необходимые меры по удалению или уточнению
                    неполных или неточных данных, в том числе в случаях, указанных в Политике.
                  </div>
                  <div className={style.text_split}>
                    26. Оператор использует необходимые организационные, технические и
                    административные меры для защиты персональных данных, полученных через Сайт, в
                    соответствии с требованиями Законодательства о ПДн.
                  </div>
                  <h2 className={style.subTitle}>
                    СРОКИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ И ПРЕКРАЩЕНИЕ ОБРАБОТКИ
                  </h2>
                  <div className={style.text_split}>
                    27. Оператор хранит персональные данные, собираемые на Сайте, в течение периода
                    времени, необходимого для целей, указанных в данной Политике, если только более
                    длительный срок хранения не является необходимым или не разрешается применимым к
                    деятельности Оператора законодательством.
                  </div>
                  <div className={style.text_split}>
                    28. Условием прекращения обработки персональных данных Оператором может являться
                    достижение целей обработки, а также выявление неправомерной обработки
                    персональных данных.
                  </div>
                  <div className={style.text_split}>
                    29. В случае выявления неправомерной обработки персональных данных, собираемых
                    через Сайт (при получении обращения от Вас или Вашего представителя, либо
                    запроса уполномоченного органа, получении результатов внутренних проверок), а
                    равно при выявлении неточных персональных данных, Оператор блокирует такие
                    неправомерно обрабатываемые персональные данные (или обеспечивает их
                    блокирование) с момента получения указанного обращения или запроса на весь
                    период проверки:
                  </div>
                  <div className={style.text_split}>
                    — в случае подтверждения факта неточности персональных данных на основании
                    сведений, представленных в письменном виде в свободной форме Вами, Вашим
                    представителем или уполномоченным органом, либо на основании иных документов в
                    порядке, предусмотренном Законодательством о ПДн, Оператор обязан уточнить такие
                    персональные данные или обеспечить их уточнение в течение 7 (семи) рабочих дней
                    со дня предоставления таких сведений и снять блокирование; <br /> — в случае
                    подтверждения факта неправомерной обработки персональных данных Оператор обязан
                    прекратить неправомерную обработку в срок, не превышающий 3 (трех) рабочих дней
                    с даты выявления факта неправомерной обработки, либо уничтожить такие
                    персональные данные в срок, не превышающий 10 (десяти) рабочих дней с даты
                    выявления факта неправомерной обработки. Об устранении допущенных нарушений
                    Оператор обязан уведомить Вас или Вашего представителя, либо уполномоченный
                    орган, если проверка правомерности обработки проводилась по запросу такого
                    органа.
                  </div>
                  <div className={style.text_split}>
                    30. При получении отзыва согласия от Вас, Оператор прекращает обработку
                    персональных данных незамедлительно, за исключением случаев, когда необходимость
                    продолжения обработки таких персональных данных обусловлена требованиями
                    применимого к деятельности Оператора законодательства, и в любом случае Оператор
                    уведомит Вас о последствиях отзыва такого согласия.
                  </div>
                  <div className={style.text_split}>
                    31. В случае достижения цели обработки персональных данных, собираемых через
                    Сайт, Оператор прекращает обработку персональных данных и уничтожает
                    персональные данные в срок, не превышающий 30 (тридцати) дней с даты достижения
                    целей обработки, если иной срок не предусмотрен в согласии, полученном
                    Оператором от Вас. В случае если невозможно уничтожить персональные данные,
                    собираемые через Сайт, в течение указанного срока, Оператор блокирует такие
                    персональные данные и обеспечивает их уничтожение в срок, не превышающий 6
                    (шести) месяцев, если иное не требуется согласно применимому к деятельности
                    Оператора законодательству, либо если иное не указано в согласии на обработку,
                    полученном Оператором от Вас, или в договоре, стороной которого Вы являетесь.
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60 * 60,
});

export default Products;
